module.exports = __webpack_public_path__ + "static/media/morphos_front_manual.08133159.svg";